import { html } from 'lit-html';
import FilterVariationsAction from '../../../actions/filter_variations_action';
import { VariationsAttrModel } from '../../../models/variations_attr_model';
import { getAssetsUrlBase } from '../../../../core/models/common/static_resource_util';

export const FilterVariationsAttr = (model: VariationsAttrModel) => {
  return html`
    <button
      class="a-deletebtn js-deletebtn"
      type="button"
      @click=${(event: Event) => FilterVariationsAction.deleteAttr(model, event)}
    >
      ${model.attrValue}
      <span class="a-icon -size8">
        <img class="a-icon_img" src="${getAssetsUrlBase()}images/icon_close.svg" alt="" width="8" height="8" />
      </span>
    </button>
  `;
};
